import { View } from "@-/com.npmjs.react-native";
import { GetStartedAuth } from "@-/dev.improve.haniverse.components.ui.get-started-auth";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@-/dev.improve.haniverse.components.ui.dialog";
import { Button } from "@-/dev.improve.haniverse.components.ui.button";
import { Text } from "@-/dev.improve.haniverse.components.ui.text";
import type { FirstLevelAccountPromptGate } from "#use-first-level-account-prompt-gate";

/**
 * Suggests creating an account once a guest has finished the first level. Dismissing it (or
 * finishing the account step) records the device setting, which closes the gate and unmounts it.
 */
export function FirstLevelAccountPrompt({ gate }: { gate: FirstLevelAccountPromptGate }) {
  const { dismiss } = gate;
  return (
    <Dialog
      onOpenChange={(open) => {
        if (!open) {
          dismiss();
        }
      }}
      open
    >
      <DialogContent testID="first-level-account-dialog">
        <DialogHeader>
          <DialogTitle>First level. First reviews. Well done!</DialogTitle>
          <DialogDescription>
            You’ve learned your first level and reviewed its cards. Create your free account to keep
            your progress and continue learning across devices.
          </DialogDescription>
        </DialogHeader>
        <View className="gap-2">
          <GetStartedAuth onContinue={dismiss} />
          <Button onPress={dismiss} testID="first-level-account-later" variant="ghost">
            <Text className="text-xs text-muted-foreground">Keep learning for now</Text>
          </Button>
        </View>
      </DialogContent>
    </Dialog>
  );
}
